const modernBrowser = window.Modernizr ? window.Modernizr.flexboxlegacy : true
const olderBrowser = !modernBrowser

export { modernBrowser, olderBrowser }
